import { categories } from "@/mocks/home";

export default function TopicSection() {
  return (
    <section id="topics" className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="reveal flex flex-col md:flex-row md:items-end md:justify-between gap-5">
          <div className="max-w-2xl">
            <span className="text-xs font-label font-medium tracking-widest text-accent-600">
              TOPIC ZONES
            </span>
            <h2 className="mt-3 font-heading text-3xl md:text-4xl font-black text-foreground-950">
              六大主题专区
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              不同板块的围观节奏不一样：娱乐看现场，社会看细节，科技看实测，财经看趋势。
            </p>
          </div>
          <a
            href="#live"
            className="inline-flex items-center gap-1.5 self-start md:self-auto px-5 py-2.5 rounded-md border border-foreground-300 text-sm font-medium text-foreground-800 whitespace-nowrap cursor-pointer transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            在信息流中筛选
            <i className="ri-filter-3-line" aria-hidden="true" />
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <article
              key={cat.id}
              className="reveal group flex flex-col rounded-lg bg-background-50 border border-background-200 p-5 md:p-6 transition-colors hover:border-accent-300"
            >
              <div className="flex items-center justify-between">
                <span
                  className="w-12 h-12 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center text-2xl transition-colors group-hover:bg-accent-500 group-hover:text-background-50"
                  aria-hidden="true"
                >
                  <i className={cat.icon} />
                </span>
                <span className="text-xs font-label text-foreground-500">
                  <span className="font-heading text-xl font-black text-foreground-900 mr-1">
                    {cat.count}
                  </span>
                  条在追
                </span>
              </div>

              <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950">{cat.name}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>

              <ul className="mt-5 pt-5 border-t border-background-200 space-y-2">
                {cat.samples.map((sample) => (
                  <li key={sample} className="flex items-start gap-2 text-sm text-foreground-700">
                    <i
                      className="ri-arrow-right-s-line text-accent-600 mt-0.5 shrink-0"
                      aria-hidden="true"
                    />
                    <span>{sample}</span>
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}